<style lang="scss" scoped>
#devolucao-page {
  .container {
    max-width: 850px;
  }
}
</style>

<template>
  <div id="devolucao-page">
    <v-container class="container" v-if="devolucao">
      <v-row v-if="devolucao.cancelado">
        <v-col>
          <v-card color="red lighten-1" dark elevation="10">
            <v-card-title>
              <v-icon left>mdi-close-octagon-outline</v-icon>
              Cancelado
            </v-card-title>
            <v-card-subtitle> Esta devolução foi cancelada </v-card-subtitle>
            <v-card-text>
              <v-list color="red lighten-1">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> Responsável </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ devolucao.cancelado_por.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Data de Cancelamento
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ formatDateTime(devolucao.cancelado_as) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card>
        <v-toolbar elevation="1" color="primary" dark>
          <v-btn @click="$router.go(-1)" exact icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>
            Devolução - {{ number }}
            <v-spacer></v-spacer>
          </v-toolbar-title>
        </v-toolbar>
      </v-card>

      <v-toolbar>
        <v-spacer></v-spacer>
        <v-btn
          @click="confirmPrintDevolucao"
          :loading="canceling"
          text
          color="primary"
          class="mr-1"
        >
          <v-icon left>mdi-printer</v-icon> Imprimir
        </v-btn>
      </v-toolbar>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <v-icon left>mdi-package-variant-closed</v-icon>
              Produtos
            </v-card-title>
            <v-card-text>
              <div
                v-for="(product, index) in devolucao.produtos"
                :key="index"
                class="mb-1"
              >
                <v-divider v-if="index > 0"></v-divider>
                <ProductCard
                  :product="product"
                  :index="index"
                  readonly
                  is-return
                />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title> <v-icon left>mdi-cash</v-icon> Total </v-card-title>

            <v-card-text>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Forma de Pagamento
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ devolucao.payment_type.description }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Total</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  {{ formatMoney(total) }}
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <v-icon left>mdi-view-list</v-icon>
              Detalhes
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle> Cliente </v-list-item-subtitle>
                    <v-list-item-title v-if="devolucao.cliente">
                      {{ devolucao.cliente.nome }}
                      <span v-if="devolucao.cliente.deleted_at">
                        (Excluído)
                      </span>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      Não identificado
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-subheader>DETALHES</v-subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Código
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ devolucao.numero }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Data da Devolução
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ formatDateTime(devolucao.created_at) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Última alteração
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ formatDateTime(devolucao.updated_at) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <v-icon left>mdi-lightning-bolt</v-icon> Ações
            </v-card-title>

            <v-list-item @click="confirmPrintDevolucao">
              <v-list-item-action>
                <v-icon color="primary">mdi-printer</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text">
                  Imprimir
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
              @click="handleCancel"
              :loading="canceling"
              v-if="!devolucao.cancelado"
            >
              <v-list-item-action>
                <v-icon color="red">mdi-close</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="red--text">
                  Cancelar Devolução
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <confirm-print
        v-model="print_dialog"
        @action="printDevolucao"
        :default_copies="2"
        message="Tem certeza que deseja imprimir o recibo desta devolução?"
      />
    </v-container>
  </div>
</template>

<script>
import { printDevolucao } from "@/services/print";

import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";

import ConfirmPrint from "@/components/ConfirmPrint";
import ProductCard from "@/components/ProductCard";

export default {
  mixins: [MoneyMixin, DateTimeMixin],
  components: { ConfirmPrint, ProductCard },
  data: function() {
    const number = this.$route.params.numero;

    return {
      number,
      devolucao: null,
      canceling: false,
      print_dialog: false
    };
  },
  methods: {
    getProductName(product) {
      return `${product.nome} ${product.marca} (${product.unidade_medida})`;
    },
    confirmPrintDevolucao() {
      this.print_dialog = true;
    },
    async printDevolucao(payload) {
      try {
        if (this.devolucao) {
          await printDevolucao(this.devolucao.id, payload);
          this.$store.commit("sendMessage", {
            text: "Recibo da devolução foi enviado para impressão",
            color: "success"
          });
        }
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível enviar este recibo para impressão",
          color: "error"
        });
      }
    },
    async handleCancel() {
      if (!confirm("Tem certeza que deseja cancelar a devolução?")) return;

      this.canceling = true;
      const response = await this.$http.delete(`/devolucoes/${this.number}`);
      this.getData();
      this.canceling = false;
    },
    handleConfirmCancellation() {},
    async getData() {
      this.$store.commit("setLoading", {
        loading: true
      });
      const response = await this.$http.get(`/devolucoes/${this.number}`);
      this.devolucao = response.data;

      this.$store.commit("setLoading", {
        loading: false
      });
    },
    calcTotalProduct(sale_product) {
      return sale_product.quantidade_produto * sale_product.preco_devolucao;
    }
  },
  computed: {
    total: function() {
      let total = 0;
      this.devolucao.produtos.forEach(product => {
        total += this.calcTotalProduct(product);
      });

      return total;
    }
  },
  created() {
    this.getData();
  }
};
</script>
